import { cn } from '@/lib/utils'
import type { RankStackRow } from './types'

export interface RankStackProps {
  rows: RankStackRow[]
  label?: string
  className?: string
}

function numericValue(value: number | string) {
  return typeof value === 'number' && Number.isFinite(value) ? value : 0
}

export function RankStack({
  rows,
  label = 'Ranked operational detail',
  className,
}: RankStackProps) {
  const max = Math.max(...rows.map((row) => numericValue(row.value)), 0)

  return (
    <ol className={cn('space-y-2', className)} aria-label={label}>
      {rows.map((row, index) => {
        const width = max > 0 ? Math.max(8, (numericValue(row.value) / max) * 100) : 0
        return (
          <li key={`${row.label}-${index}`} className="space-y-1">
            <div className="flex items-baseline justify-between gap-3 text-sm">
              <span className="min-w-0 font-medium text-foreground">
                <span className="text-muted-foreground">#{index + 1}</span>{' '}
                {row.label}
              </span>
              <span className="shrink-0 font-semibold text-foreground">
                {row.value}
              </span>
            </div>
            <div className="h-2 rounded-full bg-muted" aria-hidden="true">
              <div
                className="h-full rounded-full bg-primary"
                style={{ width: `${width}%` }}
              />
            </div>
            {row.detail ? (
              <p className="text-xs text-muted-foreground">{row.detail}</p>
            ) : null}
          </li>
        )
      })}
    </ol>
  )
}
